import { Snowflake, type LucideIcon } from 'lucide-react'
import './Logo.css'

/**
 * An app mark (squircle), design.md 7.1. ICE's mark is neutral (`tone="neutral"`: the
 * primary text color, inverted) rather than accent-filled, keeping the accent for actions.
 */
export function LogoMark({
  size = 28,
  icon: Icon = Snowflake,
  tone = 'neutral',
}: {
  size?: number
  icon?: LucideIcon
  tone?: 'neutral' | 'accent'
}) {
  return (
    <span className={`logo-mark logo-mark-${tone}`} style={{ width: size, height: size }} aria-hidden="true">
      <Icon size={Math.round(size * 0.55)} strokeWidth={size >= 20 ? 1.75 : 2} />
    </span>
  )
}
